import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import Select from "react-select";
import { CategoryGetForDropDownSlice } from "../../../redux/features/CategorySlice";
import { useDispatch, useSelector } from "react-redux";
import { InsertArticleByAPISlice } from "../../../redux/features/Publish Article By API Slices/ArticleByAPISlice";
import useParamsFormat from "../../../common/Params Values format/ParamsFormat";
import { RouteHolderHandler } from "../../../redux/features/Publish Article By Admin Slices/ArticleSlice";
import { toast } from "react-toastify";

const PublishArticleByAPIOutlet = () => {
  const location = useLocation().pathname?.split("/").splice(1);

  const [option, setOption] = useState({ options: [] });
  const { CategoryForDropDown, loading } = useSelector(
    (state) => state.Category
  );
  const { loading: importLoading } = useSelector(
    (state) => state?.ArticleByAPI
  );
  const { createDataSetParams } = useParamsFormat();

  const dispatch = useDispatch();
  const [selectedRegion, setSelectedRegion] = useState({
    category: null,
  });
  const [showImportModal, setShowImportModal] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(null);

  const languageOptions = [
    { value: "en", label: "ENGLISH" },
    { value: "hi", label: "HINDI" },
    { value: "mr", label: "MARATHI" },
    { value: "pa", label: "PUNJABLI" },
    { value: "bn", label: "BENGALI" },
    { value: "as", label: "ASSAMESE" },
    { value: "te", label: "TELUGU" },
    { value: "kn", label: "KANNADA" },
    { value: "ml", label: "MALYALAM" },
    { value: "ta", label: "TAMIL" },
  ];

  const handleConfirmImport = () => {
    if (!selectedRegion?.category || !selectedLanguage) return;

    const params = {
      category: selectedRegion?.category?.value,
      language: selectedLanguage?.value,
    };

    dispatch(InsertArticleByAPISlice(createDataSetParams(params)))
      .unwrap()
      .then(() => {
        // toast.success("Article Inserted Successfully!");
        setShowImportModal(false);
        setSelectedLanguage(null);
        setSelectedRegion({ category: null });
      })
      .catch((error) => {
        console.log(error);
        setShowImportModal(false);
        setSelectedLanguage(null);
        setSelectedRegion({ category: null });
        toast.error(error?.message || "Something went wrong!");
      });
  };

  useEffect(() => {
    dispatch(CategoryGetForDropDownSlice());
  }, []);

  
  useEffect(()=>{
    // console.log(location?.slice(location?.length-2, location?.length-1));
    if(!location?.includes("AllArticleDetails") && !location?.includes("EditPublishNewsArticle")){
      const route = location?.[location?.length - 1];
      if(!["AllArticleDetails","PublishNewsArticle","SubCategoryList","PublishArticleByAdmin","PublishArticleByAPI"]?.includes(route))
        dispatch(RouteHolderHandler(route));
    }
  },[location])

  useEffect(() => {
    const option = CategoryForDropDown?.map((item, index) => ({
      value: item?.catName,
      label: item?.catName,
    }));
    setOption((prev) => ({ ...prev, options: option })); 
  }, [CategoryForDropDown]);

  return (
    <>
      {!location?.includes('AllArticleDetails') &&!location?.includes('EditPublishNewsArticle') &&
      <div className="CommonTabs">
        <ul className="nav nav-tabs">
        <li className="nav-item">
            <Link
              className={`nav-link ${
                location?.includes("AllPendingArticlesByAPI") && "active"
              }`}
              data-toggle="tab"
              to={"AllPendingArticlesByAPI"}
            >
              All Pending Articles
            </Link>
          </li>
          <li className="nav-item mb-2">
            <Link
              className={`nav-link ${
                location?.includes("AllPublishedArticleByAPI") && "active"  
              }`}
              data-toggle="tab"
              to={"AllPublishedArticleByAPI"}
            >
              All Published Articles
            </Link>
          </li>
          <li className="nav-item">
            <Link
              className={`nav-link ${
                location?.includes("AllHiddenArticle") && "active"
              }`}
              data-toggle="tab"
              to={"AllHiddenArticle"}
            >
              Rejected Articles
            </Link>
          </li>
          {/* <li className="nav-item">
            <Link
              className={`nav-link ${
                location?.includes("NewRequest") && "active"
              }`}
              data-toggle="tab"
              to={"NewRequest"}
            >
              New Request
            </Link>
          </li> */}
          {/* <li className="nav-item">
            <Link
              className={`nav-link ${
                location?.includes("DisapprovedArticle") && "active"
              }`}
              data-toggle="tab"
              to={"DisapprovedArticle"}
            >
              Disapproved Articles
            </Link>
          </li> */}
          <li className="nav-item">
            <Link
              className={`nav-link ${
                location?.includes("DeletedArticle") && "active"
              }`}
              data-toggle="tab"
              to={"DeletedArticle"}
            >
              Deleted Articles
            </Link>
          </li>
          <li>
            <button
              className="btn btn-primary"
              type="button"
              onClick={() => setShowImportModal(true)}
            >
              Import Article
            </button>
          </li>
        </ul>
      </div>
      }

      {showImportModal && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Import Article</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setShowImportModal(false)}
                >
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <label>Select Language</label>
                  <Select
                    options={languageOptions}
                    value={selectedLanguage}
                    onChange={(e) => setSelectedLanguage(e)}
                    isSearchable={true}
                    placeholder="Select Language"
                  />
                </div>
                <div className="form-group mt-3">
                  <label>Select Category</label>
                  <Select
                    options={option?.options}
                    value={selectedRegion?.category}
                    onChange={(e) =>
                      setSelectedRegion((prev) => ({ ...prev, category: e }))
                    }
                    isSearchable={true}
                    placeholder="Select Category"
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() =>{
                     setShowImportModal(false);
                     setSelectedLanguage(null);
                     setSelectedRegion({ category: null });
                  }}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleConfirmImport}
                  disabled={
                    !selectedRegion?.category || !selectedLanguage || importLoading
                  }
                >
                  {importLoading ? "Importing..." : "Import"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div>
        <Outlet />
      </div>

    </>
  );
};

export default PublishArticleByAPIOutlet;